import React, { useEffect, useState } from 'react';
import HHSReportPdfView from "../HHS/HHSReportPdfView";

const getJsonDataFromLocalStorage = () => {
  const data = localStorage.getItem('hhsReportJson');
  return data ? JSON.parse(data) : null;
};

const HHRPdf = () => {
  const [reportData, setReportData] = useState<any | null>(getJsonDataFromLocalStorage());

  useEffect(() => {
    // Проверяем localStorage каждую секунду
    const intervalId = setInterval(() => {
      const newData = getJsonDataFromLocalStorage();
      if (JSON.stringify(newData) !== JSON.stringify(reportData)) {
        setReportData(newData);
      }
    }, 1000);

    // Обработчик событий между вкладками
    const storageHandler = (e: StorageEvent) => {
      if (e.key === 'hhsReportJson') {
        const newData = getJsonDataFromLocalStorage();
        if (JSON.stringify(newData) !== JSON.stringify(reportData)) {
          setReportData(newData);
        }
      }
    };

    window.addEventListener('storage', storageHandler);

    const chat = document.getElementById('gorgias-chat-container');
    if (chat) chat.style.display = 'none';

    return () => {
      clearInterval(intervalId);
      window.removeEventListener('storage', storageHandler);
    };
  }, [reportData]);

  if (!reportData) {
    return <div>Loading report data...</div>;
  }

  return <HHSReportPdfView key={reportData.report_data.customerId} reportData={reportData}/>;
};

export default HHRPdf;
